import { render, staticRenderFns } from "./NotificationPermissionsModal.vue?vue&type=template&id=b00336c0&scoped=true&"
import script from "./NotificationPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./NotificationPermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPermissionsModal.vue?vue&type=style&index=0&id=b00336c0&prod&lang=scss&scoped=true&"
import style1 from "./NotificationPermissionsModal.vue?vue&type=style&index=1&id=b00336c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00336c0",
  null
  
)

export default component.exports